export * from './relatedPatents';
